<template>
    <div class="select">
        <div class="select__wrapper">
            <multiselect
                v-model="value"
                :options="options"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                @close="selectClose(value)"
                placeholder="Выберите корпус"
            >
                <template slot="singleLabel" slot-scope="props">
                    <span class="option__title">{{ props.option.title }}</span>
                </template>

                <template slot="option" slot-scope="props">
                    <span class="option__title">{{ props.option.title }}</span>
                </template>
            </multiselect>
        </div>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Multiselect from 'vue-multiselect';
import Observer from 'common/scripts/observer';

const observer = new Observer();

export default {
    components: {
        Multiselect
    },

    props: ['list', 'closeOnSelect', 'isStep'],

    data() {
        return {
            options        : [],
            isInit         : false,
            closeOnSelected: false,
            value          : {
                // id   : this.$route.params.buildingId,
                // title: this.$route.params.buildingId
                id   : this.$route.params.buildingId,
                title: 'Выберите корпус'
            },
            selected: ''
        };
    },

    watch: {
        list() {
            this.setList();
        },

        // утанавливаем выбранные здания для vue-мультиселекта
        selectedObjects() {
            this.selected = [];
            this.selected = this.selectedObjects;
        }
    },

    computed: {
        ...mapGetters({
            selectedBuildings: 'GET_SELECTED_BUILDINGS',
            selectedObjects  : 'GET_SELECTED_OBJECTS',
            buildings        : 'GET_BUILDING'
        })
    },

    created() {
        this.value.id = this.$route.params.buildingId;

        if (this.value.id) {
            this.value = {
                title: this.buildings[this.value.id].title
            };
        }
    },

    mounted() {
        this.setList();

        this.subscribes();
    },

    methods: {
        ...mapActions(['closeSelected']),

        subscribes() {
            observer.subscribe('selectorVisualChange', (data) => {
                this.value = {
                    title: this.buildings[data].title
                };
            });
        },

        setList() {
            if (this.list) {
                this.options = [];
                this.closeOnSelected = this.closeOnSelect;

                for (const item in this.list) {
                    if ({}.hasOwnProperty.call(this.list, item)) {
                        const rv = {};

                        // eslint-disable-next-line no-undefined
                        if (this.list[item] !== undefined) {
                            rv[item] = this.list[item];
                            this.options.push(rv[item]);
                        }
                    }
                }
            }
        },

        selectClose(value) {
            if (value) {
                observer.publish('selectorChange', {id: value.id});
            }

            this.$emit('selectric-select');
        }
    }
};
</script>


